import { PolicyActionEnum } from '../actions.js';
import { defineBuiltinPolicy } from './types.js';

// The key keeps its `chat-` prefix: built-in keys are permanent (migrations and claim mappings refer to them).
export const chatHcpFullAccessPolicy = defineBuiltinPolicy({
  key: 'builtin:chat-hcp-full-access',
  name: 'HCP Full Access',
  description: 'See every HCP in chat search and profiles, not only those assigned to the user.',
  actions: [PolicyActionEnum.HcpProfileViewAll],
});
